export const heightVertexShader = /* glsl */ `
  varying vec2 vUv;
  varying vec3 vWorldPosition;
  uniform float uHeight;
  uniform sampler2D map;

  void main() {
    vUv = uv;
    vec4 worldPosition = modelMatrix * vec4(position, 1.0);
    vWorldPosition = worldPosition.xyz;
    float h = texture2D(map, vUv).a * uHeight;
    // gl_Position = projectionMatrix * viewMatrix * vec4(worldPosition.x, worldPosition.y, h, 1.0);
     gl_Position = projectionMatrix * modelViewMatrix * vec4(position.x, position.y, position.z, 1.0);
  }
`

const pixelGraphFunc = /* glsl */ `
vec4 createPixelGraphEffect(sampler2D map, vec2 vUv, float granularity, float threshold, vec2 range, vec3 worldPos) {
    vec2 pixelSize = vec2(1.0) / granularity;
    vec2 cell = floor(vUv / pixelSize);
    vec2 cellUv = fract(vUv / pixelSize);

    vec4 texColor = texture2D(map, (cell + 0.5) * pixelSize);

    vec2 pointCenter = vec2(0.5, 0.5);
    vec2 rotatedUv = cellUv - pointCenter;
    vec2 rotated = vec2(
      (rotatedUv.x - rotatedUv.y) * 0.7071067811865476,
      (rotatedUv.x + rotatedUv.y) * 0.7071067811865476
    );

    float dist = abs(rotated.x) + abs(rotated.y);

    float intensity = (texColor.r + texColor.g + texColor.b) / 3.0;
    float pointSize = 0.3 * smoothstep(0.0, threshold, intensity);

    if (dist > pointSize || intensity < 0.05) {
      discard;
    }

    return texColor;
}
`

export const heightFragmentShader = /* glsl */ `
  uniform sampler2D map;
  uniform float granularity;
  uniform float threshold;
  uniform vec2 uRange;
  varying vec2 vUv;
  varying vec3 vWorldPosition;
  uniform float uOpacity;
  uniform bool isPixel;

  ${pixelGraphFunc}

  void main() {
    vec4 texColor = isPixel ? 
                    createPixelGraphEffect(map, vUv, granularity, threshold, uRange, vWorldPosition) : 
                    texture2D(map, vUv);
    
    float a = texColor.a * uOpacity;
    gl_FragColor = texColor;
    gl_FragColor.a = min(a, 1.0); 

    // if(vWorldPosition.x < uRange.x || vWorldPosition.x > uRange.y || 
    //    vWorldPosition.z < uRange.x || vWorldPosition.z > uRange.y) {
    //     discard;
    // }
  }
`
